const BASE_URL = import.meta.env.VITE_API_URL ?? '/api'

async function request<T>(
  method: string,
  path: string,
  token: string,
  body?: unknown
): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  })

  const data = await res.json()

  if (!res.ok || !data.ok) {
    throw new Error(data.error ?? `HTTP ${res.status}`)
  }

  return data
}

export const api = {
  get: <T = unknown>(path: string, token: string) =>
    request<T>('GET', path, token),

  post: <T = unknown>(path: string, body: unknown, token: string) =>
    request<T>('POST', path, token, body),

  patch: <T = unknown>(path: string, body: unknown, token: string) =>
    request<T>('PATCH', path, token, body),

  delete: <T = unknown>(path: string, token: string) =>
    request<T>('DELETE', path, token),
}
